import { useEffect, useState } from 'react';

const SplashScreen = () => {
  const [phase, setPhase] = useState('show');

  useEffect(() => {
    const fade = setTimeout(() => setPhase('fade'), 2600);
    const done = setTimeout(() => setPhase('done'), 3100);
    return () => { clearTimeout(fade); clearTimeout(done); };
  }, []);

  if (phase === 'done') return null;

  return (
    <div className={`splash-screen ${phase === 'fade' ? 'splash-fade' : ''}`} data-testid="splash-screen" onClick={() => setPhase('done')}>
      <div className="splash-glow" />
      <img src="/careguard-logo-full.jpg" alt="CareGuard" className="splash-logo" data-testid="splash-logo" />
    </div>
  );
};

export default SplashScreen;
